import React, { useState } from "react";
import "./NewsLetter.css";

const NewsLetter = () => {
    const [email, setEmail] = useState("");
    const [confetti, setConfetti] = useState([]);

    const handleSubmit = (e) => {
        e.preventDefault();
        // Create confetti effect
        const newConfetti = [];
        for (let i = 0; i < 50; i++) {
            newConfetti.push({
                id: i,
                left: Math.random() * 100,
                animationDuration: Math.random() * 3 + 2,
                delay: Math.random() * 5,
                size: Math.random() * 10 + 5
            });
        }
        setConfetti(newConfetti);
        
        // Reset after animation
        setTimeout(() => setConfetti([]), 5000);
    };

    return (
        <div className="newsletter">
            {confetti.map(conf => (
                <div 
                    key={conf.id}
                    className="confetti"
                    style={{
                        left: `${conf.left}%`,
                        top: -10,
                        width: conf.size,
                        height: conf.size,
                        backgroundColor: `hsl(${Math.random() * 60 + 30}, 100%, 50%)`,
                        animation: `fall ${conf.animationDuration}s linear ${conf.delay}s forwards`,
                        opacity: 0.8,
                        position: 'absolute',
                        borderRadius: '50%'
                    }}
                />
            ))}
            <h1>Get Exclusive Offers on Your Email</h1>
            <p>Subscribe to our newsletter and stay updated</p>
            <form onSubmit={handleSubmit}>
                <div className="newsletter-input-container">
                    <input 
                        type="email" 
                        placeholder="Your email address" 
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="newsletter-input"
                    />
                    <button type="submit" className="newsletter-button">
                        Subscribe
                    </button>
                </div>
            </form>
        </div>
    );
}

export default NewsLetter;